import { css } from 'styled-components';
import { colors } from 'utils';

const { primary } = colors;

const base = css`
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans:400,700');

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans', sans-serif;
    font-size: 14px;
    background-color: ${primary.raju};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &.overflow-hidden{
      overflow-y: hidden;
    }

    #g-recaptcha{
      @media screen and (max-width: 768px){
        transform: scale(0.79);
        transform-origin: 0px 0px 0px;
      }
    }

  }
`;

export default base;



// WEBPACK FOOTER //
// ./src/components/styled/global/base.js